const ItemGenerator = require('../../../game_items/ItemGenerator');
const Dagger = require('../../../game_items/equipment/weapon/Dagger');
const MedBoots = require('../../../game_items/equipment/boots/MedBoots.js');
const MedHelmet = require('../../../game_items/equipment/helmet/MedHelmet.js');
const MedTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe.js');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const ghost = (level) => {
  const handle = 'ghost';
  const types = ['amorphous', 'flying', 'tanky', 'undead'];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(Dagger, level),
          ItemGenerator.getCavernsMobItem(MedBoots, level),
          ItemGenerator.getCavernsMobItem(MedHelmet, level),
          ItemGenerator.getCavernsMobItem(MedTorsoe, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];
  const AI_PRIORITIES = ['interference', 'dps_close', 'support', 'tank', 'dps_ranged'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'sleight_of_hand' },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'ghost_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          angel_mask: {
            handle: 'angel_mask',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          blurred_form: {
            handle: 'blurred_form',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          freedom: {
            handle: 'freedom',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          iron_will: {
            handle: 'iron_will',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          sleight_of_hand: {
            handle: 'sleight_of_hand',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          quickness: {
            handle: 'quickness',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(5 + bound_level * 0.7 + Math.random() * 3),
      perception: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      mana: Math.round(5 + bound_level * 0.7 + Math.random() * 3),
      toughness: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      strength: Math.round(3 + bound_level * 0.3 + Math.random() * 3),
      willpower: Math.round(6 + bound_level * 0.8 + Math.random() * 3),
      dexterity: Math.round(4 + bound_level * 0.6 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 300,
    drops_gold: false,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = ghost;
